import { isRevolvingCreditProduct } from './productTypeHelpers';
const isDCHCustomerAssistancePlanEnrolled = (billing, productType, featureFlags) => {
    const isEnrolledInCAP = billing === null || billing === void 0 ? void 0 : billing.customerAssistancePlan;
    return (featureFlags.isDigitalCollectionsEnabled &&
        isRevolvingCreditProduct(productType) &&
        isEnrolledInCAP);
};
export default isDCHCustomerAssistancePlanEnrolled;
